<template src="./dashboard.html"></template>
<script>
import {
  get_menu,
  disabilita_menu,
  novita_menu,
  get_coppieAgenti,
  set_coppieAgenti,
} from "@/api/api.admin.js";

import { get_listaAgenti } from "@/api/api.agenti.js";

export default {
  data: () => ({
    search: "",

    tabs: 0,
    //menu
    dati: [],
    headersMenu: [
      { text: "", align: "left", value: "Image" },
      { text: "Titolo", align: "left", value: "Text" },
      {
        text: "Tipologia",
        align: "left",
        value: "Type",
      },
      {
        text: "Abilitato",
        align: "left",
        value: "IsDisabled",
      },
      {
        text: "Novita",
        align: "left",
        value: "IsDisabled",
      },
    ],
    pagination: {
      rowsPerPage: 500,
    },

    //agenti
    headersAgenti: [
      {
        text: "Agente capo",
        value: "NomeAgenteCapo",
        align: "left",
      },
      {
        text: "Agente",
        value: "NomeAgenteFiglio",
        align: "left",
      },
    ],
    elencoAgentiTab: [],
    dialogNuovoAge: false,
    agenti: [],
    agCapoSel: "",
    agSel: "",
  }),

  methods: {
    async caricaDati() {
      await this.caricaMenu();
      await this.caricaCoppieAgenti();
      await this.getElencoAgenti();
    },

    async caricaMenu() {
      let res = await get_menu();
      if (res.data == null) return;
      this.dati = res.data;
    },

    async DisabilitaMenu(item) {
      let res = await disabilita_menu(item);
      if (res != null && res.data != null && res.data != undefined)
        this.dati = res.data;
    },

    async NovitaMenu(item) {
      let res = await novita_menu(item);
      if (res != null && res.data != null && res.data != undefined)
        this.dati = res.data;
    },

    getImg(img) {
      return this.$load.getUrlImg() + "/menu/" + img;
    },

    async caricaCoppieAgenti() {
      let res = await get_coppieAgenti();
      this.elencoAgentiTab = res.data;
    },

    async getElencoAgenti() {
      let res = await get_listaAgenti();
      this.agenti = res.data;
    },

    apriDialogAge() {
      this.dialogNuovoAge = true;
    },

    pulisci() {
      this.agCapoSel = "";
      this.agSel = "";
      this.dialogNuovoAge = false;
    },

    async salvaAgenti() {
      let par = {
        CodAgenteCapo: this.agCapoSel.CodAgente,
        CodAgenteFiglio: this.agSel.CodAgente,
      };
      let res = await set_coppieAgenti("salva", par);
      if (res.data == "OK") {
        this.$toast.info("Coppia salvata");
        this.pulisci;
        this.caricaCoppieAgenti();
      } else this.$toast.warning("Errore: " + res.data);
    },

    async eliminaAgenti(codCapo, codFiglio) {
      let confirm = await this.$root.$confirm(
        "Elimina",
        "Vuoi eliminare la coppia Agente capo/Agente ?"
      );
      if (!confirm) return;

      let par = {
        CodAgenteCapo: codCapo,
        CodAgenteFiglio: codFiglio,
      };
      let res = await set_coppieAgenti("elimina", par);
      if (res.data == "OK") {
        this.$toast.info("Coppia eliminata");
        this.caricaCoppieAgenti();
      } else this.$toast.warning("Errore: " + res.data);
    },
  },

  async mounted() {
    //aspetto qualche millisecondo cosi vue carica i dati dell'utente nello storage
    await this.$functions.delay(500);

    this.caricaDati();
  },
};
</script>